
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statutory-disclosures",
      function () {
        return require("private-next-pages/statutory-disclosures/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statutory-disclosures"])
      });
    }
  